export interface IReceiptV2 {
  officeId: string;
  officeName: string;
  shiftDate: string;
  shiftId: string;
  status: ReceiptV2Status;
  totalCharge: number;
  totalRefund: number;
  transactionDate: string;
  type: ReceiptType;
}

export enum ReceiptV2Status {
  Pending = 'pending',
  Refunded = 'refunded',
  Succeeded = 'succeeded',
}

export enum ReceiptType {
  OnsiteInterview = 'onsite_interview',
  Shift = 'shift',
  ListingFee = 'listing_fee',
}
